/* eslint-disable import/no-cycle */
import { authRequest } from '../utils/auth-wrapper';
import { apiRequest } from '../utils/api-wrapper';
import parseJwt from '../utils/jwt';

const localStorageKey = '__auth_token__';

function getAuthToken() {
  return window.localStorage.getItem(localStorageKey);
}
async function getRefreshToken() {
  const token = getAuthToken();
  if (!token) return;
  // data is an empty object to force a POST request
  const response = await apiRequest('auth/token/refresh', { data: {} });
  // eslint-disable-next-line consistent-return
  return window.localStorage.setItem(localStorageKey, response.token);
}

function login({ email, password }) {
  return authRequest('token', { email, password }).then((response) => {
    const jwtUser = parseJwt(response.token);
    window.localStorage.setItem(localStorageKey, response.token);
    return { ...response, ...jwtUser };
  });
}

function logout() {
  window.localStorage.removeItem(localStorageKey);
}

export {
  getAuthToken, getRefreshToken, login, logout, localStorageKey,
};
